import { render } from "./Aac.vue?vue&type=template&id=13b5d000&scoped=true"
import script from "./Aac.vue?vue&type=script&lang=js"
export * from "./Aac.vue?vue&type=script&lang=js"

import "./Aac.vue?vue&type=style&index=0&id=13b5d000&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b5d000"]])

export default __exports__